$(document).ready(function(){

	var historicalContextSlider = $('.slider--historicalContext');
	var collectionsSlider = $('.slider--collections');

	var defaultSliderSettings = {
		infinite: false,
		dots: false,
		arrows: true,
		prevArrow: $('.slider__nav .btn--prev'),
    nextArrow: $('.slider__nav .btn--next'),
    adaptiveHeight: true,
    mobileFirst: true,
	};

	// -- historical context slider --
	historicalContextSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
		var activeColor = $(slick.$slides[nextSlide]).css('background-color');
		document.documentElement.style.setProperty('--historicalContextActiveColor', activeColor);
	});
	historicalContextSlider.on('afterChange', function(event, slick, currentSlide){
	 var current = currentSlide+1;
	 historicalContextSlider.next('.slider__nav').find('.current').text(current);
	});
  historicalContextSlider.slick(defaultSliderSettings);

  // -- collection slider --
	collectionsSlider.slick(defaultSliderSettings);
	collectionsSlider.on('afterChange', function(event, slick, currentSlide){
	 var current = currentSlide+1;
	 collectionsSlider.next('.slider__nav').find('.current').text(current);
	});
	
});